import { noop } from "lodash";
import { QueryClient, QueryClientProvider } from "react-query";

export const mockedQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: noop,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
      retryDelay: 3000,
    },
  },
});

export interface MockedQueryClientProviderProps {
  children: React.ReactNode;
}

export const MockedQueryClientProvider = ({
  children,
}: MockedQueryClientProviderProps) => (
  <QueryClientProvider client={mockedQueryClient}>
    {children}
  </QueryClientProvider>
);
